import React from 'react';
import { LFC } from '../../../Legacy';
import { Rect } from '../../../platform/geom/Rect';
import { Colors } from '../../../ui';
import { Emoji } from '../../../ui/emoji';
import { Zone } from '../../packages/zones/Zone';
import { ZonePeers, ZonePeersAttr } from '../../packages/zones/ZoneAssociations';
import { ZoneTitleFieldTextSettings } from '../../packages/zones/ZoneTitleField';
import { RenderBorder, RenderBounds, RenderBox, RenderGraffiti, usePose } from './RenderHelpers';
import { RenderText } from './RenderText';

const bordering = ([t, r, b, l]: ZonePeers) => ({
    borderTop: `solid ${t ? .5 : 1}px ${t ? Colors.neutral100 : Colors.neutral300}`,
    borderRight: `solid ${r ? .5 : 1}px ${r ? Colors.neutral100 : Colors.neutral300}`,
    borderBottom: `solid ${b ? .5 : 1}px ${b ? Colors.neutral100 : Colors.neutral300}`,
    borderLeft: `solid ${l ? .5 : 1}px ${l ? Colors.neutral100 : Colors.neutral300}`,
});

const rounding = ([t, r, b, l]: ZonePeers, size: number) => ({
    borderTopLeftRadius: t || l ? 0 : size,
    borderTopRightRadius: t || r ? 0 : size,
    borderBottomLeftRadius: b || l ? 0 : size,
    borderBottomRightRadius: b || r ? 0 : size,
});

const RenderInner = ({ object }: { object: Zone }) => {
    const peers = ZonePeersAttr.get(object);
    // const borderColor = !!object.autoColor ? tintSafe(.5, object.autoColor) : '#ddd';
    const borderColor = object.autoColor;
    const { border, layout } = object;
    const base = layout.base;
    return <>
        <RenderBox background="white" {...base.toCSS()} {...bordering(peers)} {...rounding(peers, 4)} />
        <RenderBox borderColor={borderColor} {...base.toCSS()} {...rounding(peers, 4)}
            borderLeftWidth={border[0]}
            borderTopWidth={border[1]}
            borderRightWidth={border[2]}
            borderBottomWidth={border[3]}
        />
    </>;
};

const RenderHeading = ({ object }: { object: Zone }) => {
    // const background = useMemo(() => !!object.autoColor ? tintSafe(.5, object.autoColor) : '#ddd', [object.autoColor]);
    const background = object.autoColor;
    if (object.headingStyle !== 'fill' && object.headingStyle !== 'roundFill') return null;
    const borderRadius = object.headingStyle === 'roundFill' ? '9999px' : '2px';
    return <RenderBox {...{ background, borderRadius }} {...object.layout.heading.toCSS()} />;
};

const RenderEmoji = React.memo<{ area: Rect, value: string }>(({ area, value }) => {

    const style = {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: `${area.height * .75}px`,
    };

    return <RenderBox className="emoji-block-fix" {...area.toCSS()} {...style}>
        <Emoji idOrCode={value} />
    </RenderBox>;
});

export const ZoneVisual: LFC<{ object: Zone }> = ({ object, children }) => {

    const pose = usePose(object);
    const { beingEdited } = pose;

    const borderStyling = {
        width: object.width,
        height: object.height,
    };

    return <>
        <RenderBounds object={object}>
            <RenderBorder pose={pose} style={borderStyling}>
                {/* <RenderColor layout={object.layout} peers={ZonePeersAttr.get(object)} color={object.autoColor} /> */}
                <RenderInner object={object} />
                <RenderHeading object={object} />
                <RenderGraffiti object={object} />
                <RenderEmoji area={object.layout.emoji} value={object.emoji} />
                {!beingEdited && <>
                    <RenderText
                        bounds={object.layout.title}
                        settings={ZoneTitleFieldTextSettings(object)}
                        value={object.title}
                    />
                </>}
            </RenderBorder>
        </RenderBounds>
        {children}
    </>;
};
